import { clsx } from 'clsx'

import {
  Button,
  Card,
  EmptyState,
  Flex,
  PlusIcon,
  Text,
} from '@buffer-mono/popcorn'

import { OpenChannelStoreFrontTrigger } from '~publish/components/OpenChannelStoreFrontTrigger'

import styles from './ConnectChannelBanner.module.css'

import type { JSX } from 'react'

const CONNECT_CHANNEL_CTA =
  'publish-insights-allChannelsEmptyState-connectChannel-1'

const DECORATION_CHIPS: Array<{
  emoji: string
  tone: string
  position: string
}> = [
  { emoji: '🎯', tone: styles.chipBlue, position: styles.chip1 },
  { emoji: '📈', tone: styles.chipYellow, position: styles.chip2 },
  { emoji: '📊', tone: styles.chipBlue, position: styles.chip3 },
  { emoji: '🔍', tone: styles.chipTeal, position: styles.chip4 },
]

const BLANK_CHIPS: Array<{ tone: string; position: string }> = [
  { tone: styles.chipGreen, position: styles.blank1 },
  { tone: styles.chipYellow, position: styles.blank2 },
  { tone: styles.chipBlue, position: styles.blank3 },
]

/**
 * Hero banner shown to brand-new users with no channels connected. Invites
 * them to connect a channel so Insights has data to display.
 */
export function ConnectChannelBanner(): JSX.Element {
  return (
    <Card padding="none" className={styles.banner}>
      <Flex aria-hidden className={styles.decorations}>
        {DECORATION_CHIPS.map(({ emoji, tone, position }) => (
          <Text
            as="span"
            key={emoji}
            className={clsx(styles.chip, tone, position)}
          >
            {emoji}
          </Text>
        ))}
        {BLANK_CHIPS.map(({ tone, position }) => (
          <Text
            as="span"
            key={position}
            className={clsx(styles.chip, tone, position)}
          >
            <span className={styles.ghostGlyph}>📊</span>
          </Text>
        ))}
        <Flex className={styles.decorationsWash} />
      </Flex>

      <EmptyState size="xlarge" className={styles.content}>
        <EmptyState.Heading as="h2" className={styles.heading}>
          Turn your posts into insights <span aria-hidden="true">🔥</span>
        </EmptyState.Heading>
        <EmptyState.Description>
          Understand your performance and spot opportunities without the
          guesswork.
        </EmptyState.Description>
        <EmptyState.Actions>
          <OpenChannelStoreFrontTrigger cta={CONNECT_CHANNEL_CTA}>
            <Button size="large">
              <PlusIcon />
              Connect a Channel
            </Button>
          </OpenChannelStoreFrontTrigger>
        </EmptyState.Actions>
      </EmptyState>
    </Card>
  )
}
